import { Button, Dialog } from '@mui/material'
import classNames from 'classnames/bind'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { selectRestaurant } from '~/redux/restaurantSlice'
import { path } from '~/routes/path'
import styles from './index.module.scss'
import { selectPopupTopPage } from '~/redux/popupTopPageSlice'
import STORAGE_KEYS from '~/constants/localStorage'
import { LINE } from '~/assets/images'
import PropTypes from 'prop-types'

const cx = classNames.bind(styles)

// Component hiển thị add friend qua LINE
const PopupAddFriendLine = ({ isOpen, setIsOpen }) => {
  const locale = localStorage.getItem(STORAGE_KEYS.LOCALE)
  const { open: openPopupTopPage } = useSelector(selectPopupTopPage)
  const { t } = useTranslation()
  const location = useLocation()
  const { pathname } = location

  const { restaurantId, restaurantSlug, tableUid, line_page_url } = useSelector(selectRestaurant)

  const isTokenRedirectPath = `/${restaurantSlug}/${tableUid}` === pathname

  useEffect(() => {
    if (
      !restaurantId || // Ban đầu sẽ chưa có id
      !line_page_url || // Không url line thì không hiển thị
      isTokenRedirectPath || // Nếu đang là màn hình token redirect thì không hiển thị
      pathname === path.rescanQR || // Nếu là màn hình re-scan cũng không hiển thị
      pathname === path.introduction || // Nếu màn hình top page -> không hiển thị
      !locale // Trường hợp chưa có ngôn ngữ thì sẽ không hiển thị popup này
    ) {
      return
    }

    // Tạo key duy nhất cho từng nhà hàng trong localStorage
    const popupKey = `${STORAGE_KEYS.ADD_FRIEND_LINE}_${restaurantId}`
    const hasBeenOpened = localStorage.getItem(popupKey) === 'true'

    // Hiển thị popup nếu chưa từng mở cho nhà hàng hiện tại
    if (!hasBeenOpened) {
      setIsOpen(true)
    }
  }, [isTokenRedirectPath, line_page_url, locale, pathname, restaurantId, openPopupTopPage])

  const handleAddFriend = () => {
    // Redirect đến trang Line friend
    // Mở URL trong một tab mới
    window.open(line_page_url, '_blank')

    // Lưu trạng thái vào localStorage
    const popupKey = `${STORAGE_KEYS.ADD_FRIEND_LINE}_${restaurantId}`
    localStorage.setItem(popupKey, 'true')

    setIsOpen(false)
  }

  const handleClose = () => {
    // Lưu trạng thái vào localStorage
    const popupKey = `${STORAGE_KEYS.ADD_FRIEND_LINE}_${restaurantId}`
    localStorage.setItem(popupKey, 'true')

    setIsOpen(false)
  }

  const renderContent = () => (
    <div className={cx('content')}>
      <img src={LINE} alt="line" className={cx('logo')} />
      <p className={cx('description')}>{t('popup_add_friend_line.description')}</p>
      <Button className={cx('add_btn')} onClick={handleAddFriend}>
        {t('popup_add_friend_line.add_friend_btn')}
      </Button>
      <Button className={cx('skip_btn')} variant="text" onClick={handleClose}>
        {t('popup_add_friend_line.already_added')}
      </Button>
    </div>
  )

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="Add friend LINE"
      aria-describedby="Add friend LINE Popup"
      classes={{
        paper: cx('paper'),
      }}>
      {renderContent()}
    </Dialog>
  )
}

PopupAddFriendLine.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
}

export default React.memo(PopupAddFriendLine)
